// --------------------------------------------------------------------------
// stickyAlert.js
// --------------------------------------------------------------------------
// Uses Waypoints to create a fixed alert message
// --------------------------------------------------------------------------
RN.stickyAlert = (function () {
    "use strict";

    var stickyAlert;

    function init() {
        stickyAlert = byBehaviour("sticky-alert");
        var vanillaStickyAlert = stickyAlert[0];

        fetch("/api/alert")
            .then(function (response) {
                if (!response.ok) {
                    throw new Error("Network response was not ok");
                }
                return response.json();
            })
            .then(function (data) {
                if (data.active) {
                    vanillaStickyAlert.classList.add("global-alert--active");
                    var displayIconMarkup = data.displayIcon
                        ? '<svg class="alert__icon" role="presentation"><use xlink:href="#icon-' +
                          data.iconId +
                          '"></use></svg>'
                        : "";
                    var markup =
                        '<div class="alert alert--' +
                        data.type +
                        '" data-element="alert">' +
                        displayIconMarkup +
                        '<p class="alert__text" role="alert">' +
                        data.message +
                        "</p>" +
                        '<button class="alert__close" data-closed-message="1" data-behaviour="close-alert">' +
                        "Dismiss notification" +
                        '<svg class="alert__close-icon" role="presentation"><use xlink:href="#icon-close"></use></svg>' +
                        "</button>" +
                        "</div>";
                    vanillaStickyAlert.innerHTML = markup;
                    RN.closeAlert.init();

                    if (vanillaStickyAlert.length > 0) {
                        setWaypoints();
                    }
                }
            })
            .catch(function (error) {
                console.error("Fetch error:", error);
            });
    }

    function setWaypoints() {
        var trigger = byElement("sticky-alert-waypoint")[0],
            waypoint = new Waypoint({
                element: trigger,
                handler: function (direction) {
                    if (direction === "down") {
                        stickyAlert.css("height", stickyAlert.height());
                        stickyAlert.addClass("global-alert--stuck");
                    } else if (direction === "up") {
                        stickyAlert.css("height", "auto");
                        stickyAlert.removeClass("global-alert--stuck");
                    }
                },
                offset: -(trigger.clientHeight + 100),
            });
    }

    return {
        init: init,
    };
})();
